import React, { useEffect, useState, useRef  } from "react";
import { FileUploader } from "baseui/file-uploader";
import { Modal, ModalBody, ModalHeader } from "baseui/modal";

export default function ImageUploaderComponent(props) {
  const [imageFile, setImageFile] = useState(props.backgroundImage);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const uploaderRef = useRef();

  useEffect(() => {
    setImageFile(props.backgroundImage);
  }, [props.backgroundImage]);
  const toggleModal = (event) => {
    // Check if the click event is from the 'Browse files' button
    if (event.target && event.target.innerText === 'Browse files') {
      return; // Do nothing if the click is from the 'Browse files' button
    }
    setIsModalOpen(!isModalOpen);
  };
  return (
    <>
      <div ref={uploaderRef}>
        <FileUploader
          disabled={props.disabled}
          accept="image/*"
          onDrop={(acceptedFiles, rejectedFiles) => {
            // handle file upload...
            props.handleUploadFiles(acceptedFiles[0]);
          }}
          overrides={{
            FileDragAndDrop: {
              style: (properties) => ({
                height: props.height,
                borderLeftColor: properties.$isDragActive
                  ? properties.$theme.colors.positive
                  : properties.$theme.colors.accent,
                borderRightColor: properties.$isDragActive
                  ? properties.$theme.colors.positive
                  : properties.$theme.colors.accent,
                borderTopColor: properties.$isDragActive
                  ? properties.$theme.colors.positive
                  : properties.$theme.colors.accent,
                borderBottomColor: properties.$isDragActive
                  ? properties.$theme.colors.positive
                  : properties.$theme.colors.accent,
                backgroundImage: `url(${imageFile || require('../../../images/empty.jpg')})`,
                backgroundSize: "cover",
                cursor: 'pointer',
              }),
              props: {
                onClick: toggleModal,
              },
            },
            ContentMessage: {
              style: (props) => ({
                color: props.$theme.colors.accent,
              }),
            },
            ContentSeparator: {
              style: (props) => ({
                color: props.$theme.colors.accent,
              }),
            },
          }}
        />
      </div>

<Modal onClose={() => setIsModalOpen(false)} isOpen={isModalOpen} closeable>
        <ModalHeader>Image Preview</ModalHeader>
        <ModalBody>
          <img src={imageFile || require('../../../images/empty.jpg')} alt="Background" style={{ width: '100%' }} />
        </ModalBody>
      </Modal>
    </>
  );
}
